<template>
    <div class="card">
        <div class="card-header">
            <h2 class="card-title fw-bolder">{{ $t('pages.module.eTep.question.save.questionType.writeParagraph.title') }}</h2>
        </div>
        <div class="card-body d-flex flex-column p-9">
            <div class="fv-row mb-7">
                <label class="required fs-6 fw-bold mb-2">{{ $t('pages.module.eTep.question.save.questionType.writeParagraph.cols.content') }}</label>
                <el-form-item prop="data.data.content" :rules="$validation.getMessage(['required'])">
                    <CustomCkeditor :model="data.content" @updateModel="data.content = $event"></CustomCkeditor>
                </el-form-item>
            </div>
            <div class="fv-row mb-7">
                <label class="required fs-6 fw-bold mb-2">{{ $t('pages.module.eTep.question.save.questionType.writeParagraph.cols.minWord') }}</label>
                <el-form-item prop="data.data.options.min_word" :rules="$validation.getMessage(['required'])">
                    <el-input-number v-model="data.options.min_word" :min="1"/>
                </el-form-item>
            </div>
            <div class="fv-row mb-7">
                <label class="required fs-6 fw-bold mb-2">{{ $t('pages.module.eTep.question.save.questionType.writeParagraph.cols.maxWord') }}</label>
                <el-form-item prop="data.data.options.max_word" :rules="$validation.getMessage(['required'])">
                    <el-input-number v-model="data.options.max_word" :min="1"/>
                </el-form-item>
            </div>
        </div>
    </div>
</template>

<script>
import CustomCkeditor from "@/components/custom-ckeditor/index.vue";
import md5 from 'md5'

export default {
    name: "WriteParagraph",
    props: {
        data: Object,
    },
    data() {
        return {
            paragraphPreview: true,
        }
    },
    components: {
        CustomCkeditor
    },
};
</script>
